import React from "react";
import { Outlet } from "react-router";
import { ErrorBoundary, Toast, useScrollRestoration } from "@sscs/ui";
import { UnsavedChanges } from "Modules/notification";
import { areAnalyticsUsed, isGtmUsed } from "Utils";
import Content from "../../../components/PublicLayout/Content/Content";
import Banner from "../components/Banner/Banner";
import CookieConsentBanner from "../components/CookieConsentBanner/CookieConsentBanner";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import RequireAuth from "../components/RequireAuth";
import RequireGroup from "../components/RequireGroup";
import styles from "./layout.module.scss";

const Layout = (): React.JSX.Element => {
  useScrollRestoration(() => document.getElementById("content"));

  return (
    <RequireAuth>
      <div className={styles["layout-root"]}>
        <UnsavedChanges />
        <ErrorBoundary key="header">
          <Banner />
          <Header />
        </ErrorBoundary>
        <Content className={styles["main-content"]} scrollContainer>
          <ErrorBoundary key="content">
            <RequireGroup>
              <Outlet />
            </RequireGroup>
          </ErrorBoundary>
        </Content>
        <ErrorBoundary key="footer">
          <Footer />
        </ErrorBoundary>
        {/* Toast container needs to be within react router component so router links will work in toasts */}
        <Toast.Container />
        <CookieConsentBanner
          analyticsUsed={areAnalyticsUsed()}
          gtmUsed={isGtmUsed()}
        />
      </div>
    </RequireAuth>
  );
};

export default Layout;
